"use strict";
/**
 * Перечисления домена, общие для backend и frontend.
 *
 * Все значения хранятся в базе строками (документ «Схема данных», §2.5):
 * это позволяет добавлять новые значения без миграции PostgreSQL enum.
 * Единственный источник истины о допустимости значения — этот файл.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CURRENCY_MINOR_DIGITS = exports.CURRENCY_SYMBOLS = exports.CURRENCIES = exports.ACTIVITY_ACTION_LABELS_RU = exports.ACTIVITY_ACTIONS = exports.ACCOUNT_ACCESS_LEVEL_LABELS_RU = exports.ACCOUNT_ACCESS_LEVELS = exports.REVIEW_DECISION_LABELS_RU = exports.REVIEW_DECISIONS = exports.RELATION_LABELS_RU = exports.RELATION_TYPES = exports.PRIORITY_RANK = exports.PRIORITY_LABELS_RU = exports.PRIORITIES = exports.REQUIREMENT_STATUS_LABELS_RU = exports.REQUIREMENT_STATUSES = exports.STAGE_STATUS_LABELS_RU = exports.STAGE_STATUSES = exports.WORKSTREAM_STATUS_LABELS_RU = exports.WORKSTREAM_STATUSES = exports.PROJECT_STATUS_LABELS_RU = exports.PROJECT_STATUSES = exports.ROLE_PERMISSIONS = exports.PROJECT_PERMISSIONS = exports.ROLE_RANK = exports.MEMBER_ROLE_LABELS_RU = exports.MEMBER_ROLES = exports.USER_STATUS_LABELS_RU = exports.USER_STATUSES = void 0;
exports.roleHasPermission = roleHasPermission;
// --- Пользователи --------------------------------------------------------
exports.USER_STATUSES = ['INVITED', 'ACTIVE', 'DISABLED'];
exports.USER_STATUS_LABELS_RU = {
    INVITED: 'Приглашён',
    ACTIVE: 'Активен',
    DISABLED: 'Отключён',
};
// --- Роли ----------------------------------------------------------------
exports.MEMBER_ROLES = ['OWNER', 'ADMIN', 'MEMBER', 'VIEWER'];
exports.MEMBER_ROLE_LABELS_RU = {
    OWNER: 'Владелец',
    ADMIN: 'Администратор',
    MEMBER: 'Участник',
    VIEWER: 'Наблюдатель',
};
/**
 * Порядок ролей по убыванию полномочий. Используется для сравнений вида
 * «роль не ниже ADMIN» и для запрета понижения последнего владельца.
 */
exports.ROLE_RANK = {
    OWNER: 4,
    ADMIN: 3,
    MEMBER: 2,
    VIEWER: 1,
};
/**
 * Матрица прав первой версии (документ «Технический план», §8).
 * Проверяется в application service, а не только в интерфейсе.
 */
exports.PROJECT_PERMISSIONS = [
    'PROJECT_READ',
    'ITEM_WRITE',
    'COMMENT_WRITE',
    'REVIEW_WRITE',
    'STAGE_WRITE',
    'MEMBER_ADD',
    'MEMBER_ROLE_CHANGE',
    'PROJECT_ARCHIVE',
    'OWNERSHIP_TRANSFER',
];
exports.ROLE_PERMISSIONS = {
    OWNER: exports.PROJECT_PERMISSIONS,
    ADMIN: [
        'PROJECT_READ',
        'ITEM_WRITE',
        'COMMENT_WRITE',
        'REVIEW_WRITE',
        'STAGE_WRITE',
        'MEMBER_ADD',
        'MEMBER_ROLE_CHANGE',
    ],
    MEMBER: ['PROJECT_READ', 'ITEM_WRITE', 'COMMENT_WRITE', 'REVIEW_WRITE', 'STAGE_WRITE'],
    VIEWER: ['PROJECT_READ'],
};
function roleHasPermission(role, permission) {
    return exports.ROLE_PERMISSIONS[role].includes(permission);
}
// --- Проект --------------------------------------------------------------
exports.PROJECT_STATUSES = ['IDEA', 'ACTIVE', 'PAUSED', 'COMPLETED'];
exports.PROJECT_STATUS_LABELS_RU = {
    IDEA: 'Идея',
    ACTIVE: 'В работе',
    PAUSED: 'На паузе',
    COMPLETED: 'Завершён',
};
// --- Направления ---------------------------------------------------------
exports.WORKSTREAM_STATUSES = ['NOT_STARTED', 'ACTIVE', 'BLOCKED', 'DONE'];
exports.WORKSTREAM_STATUS_LABELS_RU = {
    NOT_STARTED: 'Не начато',
    ACTIVE: 'В работе',
    BLOCKED: 'Заблокировано',
    DONE: 'Завершено',
};
// --- Этапы и требования --------------------------------------------------
exports.STAGE_STATUSES = ['UPCOMING', 'CURRENT', 'COMPLETED', 'SKIPPED'];
exports.STAGE_STATUS_LABELS_RU = {
    UPCOMING: 'Предстоит',
    CURRENT: 'Текущий',
    COMPLETED: 'Завершён',
    SKIPPED: 'Пропущен',
};
exports.REQUIREMENT_STATUSES = ['TODO', 'IN_PROGRESS', 'BLOCKED', 'DONE', 'SKIPPED'];
exports.REQUIREMENT_STATUS_LABELS_RU = {
    TODO: 'Не начато',
    IN_PROGRESS: 'В работе',
    BLOCKED: 'Заблокировано',
    DONE: 'Выполнено',
    SKIPPED: 'Пропущено',
};
// --- Приоритет -----------------------------------------------------------
exports.PRIORITIES = ['LOW', 'MEDIUM', 'HIGH', 'CRITICAL'];
exports.PRIORITY_LABELS_RU = {
    LOW: 'Низкий',
    MEDIUM: 'Средний',
    HIGH: 'Высокий',
    CRITICAL: 'Критический',
};
exports.PRIORITY_RANK = {
    CRITICAL: 4,
    HIGH: 3,
    MEDIUM: 2,
    LOW: 1,
};
// --- Связи ---------------------------------------------------------------
exports.RELATION_TYPES = [
    'RELATED_TO',
    'SUPPORTS',
    'CONTRADICTS',
    'ANSWERS',
    'BLOCKS',
    'PRODUCED',
    'REQUIRED_FOR',
    'SUPERSEDES',
];
/** Подпись связи в прямом направлении и в обратном (для backlinks). */
exports.RELATION_LABELS_RU = {
    RELATED_TO: { forward: 'связано с', backward: 'связано с' },
    SUPPORTS: { forward: 'подтверждает', backward: 'подтверждается' },
    CONTRADICTS: { forward: 'противоречит', backward: 'опровергается' },
    ANSWERS: { forward: 'отвечает на', backward: 'ответ получен из' },
    BLOCKS: { forward: 'блокирует', backward: 'заблокировано' },
    PRODUCED: { forward: 'создало', backward: 'создано в' },
    REQUIRED_FOR: { forward: 'необходимо для', backward: 'требует' },
    SUPERSEDES: { forward: 'заменяет', backward: 'заменено' },
};
// --- Проверка материалов -------------------------------------------------
exports.REVIEW_DECISIONS = ['APPROVED', 'NEEDS_CHANGES'];
exports.REVIEW_DECISION_LABELS_RU = {
    APPROVED: 'Принято',
    NEEDS_CHANGES: 'Нужны правки',
};
// --- Доступ к аккаунтам --------------------------------------------------
exports.ACCOUNT_ACCESS_LEVELS = ['OWNER', 'ADMIN', 'USER', 'RECOVERY_CONTACT'];
exports.ACCOUNT_ACCESS_LEVEL_LABELS_RU = {
    OWNER: 'Владелец',
    ADMIN: 'Администратор',
    USER: 'Пользователь',
    RECOVERY_CONTACT: 'Контакт восстановления',
};
// --- Activity Log --------------------------------------------------------
exports.ACTIVITY_ACTIONS = [
    'PROJECT_CREATED',
    'PROJECT_UPDATED',
    'PROJECT_ARCHIVED',
    'MEMBER_ADDED',
    'MEMBER_ROLE_CHANGED',
    'MEMBER_REMOVED',
    'WORKSTREAM_CREATED',
    'WORKSTREAM_UPDATED',
    'ITEM_CREATED',
    'ITEM_UPDATED',
    'ITEM_STATUS_CHANGED',
    'ITEM_ARCHIVED',
    'ITEM_REVIEWED',
    'RELATION_CREATED',
    'RELATION_DELETED',
    'COMMENT_CREATED',
    'COMMENT_DELETED',
    'ATTACHMENT_UPLOADED',
    'ATTACHMENT_DELETED',
    'ASSET_VERSION_CREATED',
    'STAGE_CREATED',
    'STAGE_CHANGED',
    'REQUIREMENT_CREATED',
    'REQUIREMENT_UPDATED',
    'REQUIREMENT_COMPLETED',
    'PROJECT_EXPORTED',
];
/**
 * Подписи действий журнала.
 *
 * Формулировки безличные («создание элемента», а не «создал элемент»):
 * глагол прошедшего времени в русском языке имеет род, и подпись вида
 * «Анна Ковалёва создал элемент» была бы просто неверной. Род участника
 * системе неизвестен и знать его она не должна.
 */
exports.ACTIVITY_ACTION_LABELS_RU = {
    PROJECT_CREATED: 'создание проекта',
    PROJECT_UPDATED: 'изменение проекта',
    PROJECT_ARCHIVED: 'архивирование проекта',
    MEMBER_ADDED: 'добавление участника',
    MEMBER_ROLE_CHANGED: 'изменение роли участника',
    MEMBER_REMOVED: 'исключение участника',
    WORKSTREAM_CREATED: 'создание направления',
    WORKSTREAM_UPDATED: 'изменение направления',
    ITEM_CREATED: 'создание элемента',
    ITEM_UPDATED: 'изменение элемента',
    ITEM_STATUS_CHANGED: 'смена статуса',
    ITEM_ARCHIVED: 'архивирование элемента',
    ITEM_REVIEWED: 'проверка материала',
    RELATION_CREATED: 'создание связи',
    RELATION_DELETED: 'удаление связи',
    COMMENT_CREATED: 'комментарий',
    COMMENT_DELETED: 'удаление комментария',
    ATTACHMENT_UPLOADED: 'загрузка файла',
    ATTACHMENT_DELETED: 'удаление файла',
    ASSET_VERSION_CREATED: 'новая версия актива',
    STAGE_CREATED: 'создание этапа',
    STAGE_CHANGED: 'смена текущего этапа',
    REQUIREMENT_CREATED: 'добавление требования',
    REQUIREMENT_UPDATED: 'изменение требования',
    REQUIREMENT_COMPLETED: 'выполнение требования',
    PROJECT_EXPORTED: 'экспорт проекта',
};
// --- Валюты --------------------------------------------------------------
/**
 * Валюты, доступные в интерфейсе. Суммы разных валют никогда не складываются
 * без явно заданного курса (документ «Структура интерфейса», §15).
 */
exports.CURRENCIES = ['EUR', 'USD', 'RUB', 'GBP', 'PLN'];
exports.CURRENCY_SYMBOLS = {
    EUR: '€',
    USD: '$',
    RUB: '₽',
    GBP: '£',
    PLN: 'zł',
};
/** Число знаков после запятой у валюты. Все текущие валюты — два знака. */
exports.CURRENCY_MINOR_DIGITS = {
    EUR: 2,
    USD: 2,
    RUB: 2,
    GBP: 2,
    PLN: 2,
};
//# sourceMappingURL=enums.js.map